import {useReducer} from "react";
import {initialState, reducer} from "./Reducer";
import PopupContext from "./PopupContext";

export const PopupProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <PopupContext.Provider value={[state, dispatch]}>
            {children}
        </PopupContext.Provider>
    );
};